export default __webpack_public_path__ + "static/cocoCola-6d2595100743d515d713e1871a85c5b5.svg";